
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import { useRefresh } from '../../hooks/useRefresh';
import ListProducts from './ListProducts';
import BeerScreen from './beer'
import CategoriesScreen from './categories';
import SignatureCocktails from './sigatureCocktails';
import MargaritaScreen from './margaritas';

// import MargaritasScreen from './margaritas.js'
// import WinesScreen from './wines.js'
// import SpiritsScreen from './spirits.js'
// import BottlesScreen from './bottles.js'

function Index({setShowHappy}) { 

    const {i18n} = useTranslation();

        const {change} = useRefresh();
    
    const [menus, setMenus] = useState([]);
    const [showSignature, setShowSignature] = useState(false);
    const [showmargaritas, setshowmargaritas] = useState(false);

    const [showSpecials, setShowSpecials] = useState(false);
    const [showCoctatik, setshowCoctatik] = useState(false);
    const [showBeers, setshowBeers] = useState(false);
     const [showCategories, setshowCategories] = useState(false);
     const [showListProduct, setShowListProduct] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [beers, setbeers] = useState(false);

    const Card = ({ image, label, onClick }) => (
        <div
            onClick={onClick}
            style={{
                width: '32%',
                borderRadius: 18,
                overflow: 'hidden',
                position: 'relative',
                border: '2px solid rgba(255,255,255,0.6)',
                boxShadow: '0 6px 14px rgba(0,0,0,0.2)',
                cursor: 'pointer',
                height: 210,
            }}
        >
            <img
                src={image}
                onContextMenu={(e) => e.preventDefault()}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    pointerEvents: 'none',
                }}
            />
            <div
                style={{
                    position: 'absolute',
                    top: 8,
                    left: 8,
                    right: 8,
                    textAlign: 'center',
                    color: 'white',
                    fontSize: 16,
                    fontWeight: '700',
                    textShadow: '0px 2px 4px rgba(0,0,0,0.6)',
                    fontFamily: 'Abril',
                }}
            >
                {label}
            </div>
        </div>
    );

        
    useEffect(() => {
        getData('menu').then((items) => {
            // Sin menu en disco todavia: no reventar la app entera.
            if (!items?.value?.data) return;
            const data = items.value.data;
            
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
            if (item.id === 565) {
                setshowCoctatik(item);
            }
                 if (item.id === 564) {
                setbeers(item);
            }
           
            });
      }, [menus]);
    
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent  goCategories={setshowCategories} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div style={{padding: '0 20px'}}>
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <img
                            src={require('./assets/logo.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: 340, height: 100, objectFit: 'contain', pointerEvents: 'none'}}
                        />
                    </div>

                    <div style={{marginTop: 10}}>
                        <img
                            src={require('../../components/layouts/content2/assets/bannerCocktIL.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: '100%', height: 330, objectFit: 'cover', borderRadius: 18, pointerEvents: 'none'}}
                        />
                    </div>

                    <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 16, gap: 10}}>
                        <Card
                            image={require('../../components/layouts/content2/assets/signatureCoctacil.png')}
                            label="Signature Cocktails"
                            onClick={() => {
                                setdishs(showCoctatik);
                                setShowSignature(true);
                            }}
                        />
                        <Card
                            image={require('../../components/layouts/content2/assets/frozenCocktail.png')}
                            label="Frozen Cocktails"
                            onClick={() => {
                                setshowmargaritas(true);
                            }}
                        />
                        <Card
                            image={require('../../components/layouts/content2/assets/clasicCocktail.png')}
                            label="Classic Cocktails"
                            onClick={() => {
                                setdishs(beers);
                                setShowListProduct(true);
                            }}
                        />
                    </div>
                </div>
                                        
                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

                {showSignature && <SignatureCocktails 
                    dishs={dishs} 
                    setShowHappy={setShowSignature} 
                />}

                {showBeers && <BeerScreen setShowHappy={setshowBeers} />}
                {showmargaritas && <MargaritaScreen setShowHappy={setshowmargaritas} />}
                
                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
            </LayoutContent>
        </div>
    );
}
export default Index;